import { Moment } from 'moment';

import { GenericProgramStep, GenericProgramStepProps, GenericProgramWeek } from './programsGeneric';

export enum ProgramEnum {
    CP = 'core-pillars',
    PFA = 'psychological-first-aid',
    CBT = 'uplift',
}

export enum ProgramWeekEnum {
    WeekOne = 'week-1',
    WeekTwo = 'week-2',
    WeekThree = 'week-3',
    WeekFour = 'week-4',
    WeekFive = 'week-5',
    WeekSix = 'week-6',
    WeekSeven = 'week-7',
    WeekEight = 'week-8',
}

export enum ProgramSharedStep {
    WellbeingCheckInStep = 'wellbeing-check',
    WellbeingScoreStep = 'wellbeing-score',
    ProgramOverviewStep = 'program-overview',
    PlanStep = 'over-the-next-week',
    FeedbackStep = 'feedback',
    EndOfCourseStep = 'end-of-the-course',
    CongratulationsStep = 'congratulations',
    ProgramFeedbackStep = 'program-feedback',
}

export interface ProgramAndWeekIds {
    programId: ProgramEnum;
    weekId: ProgramWeekEnum;
}

export type ProgramSharedStepProps = StepProps<ProgramSharedStep>;

export interface StepProps<TProgramStep = GenericProgramStep> {
    id: TProgramStep;
    component: React.ComponentType;
    tooltip: string;
    noButtons?: boolean;
    grayBackground?: boolean;
    flexGrow?: boolean;
}

export interface WeekProgress {
    currentStep: GenericProgramStep | null;
    isUnlocked?: boolean;
    isStarted?: boolean;
    isCompleted?: boolean;
    startedAt?: Moment | null;
    completedAt?: Moment | null;
}

export type ProgramWeeksProgress = Record<number, WeekProgress>;

export type ProgramsProgress = Record<string, ProgramWeeksProgress>;

export interface FetchedWeekProgress extends WeekProgress {
    number: number;
}

export interface FetchedProgramProgress {
    programId: ProgramEnum;
    activated: boolean;
    activatedAt: Moment | null;
    currentStep: GenericProgramStep;
    weeksAvailability: FetchedWeekProgress[];
}

export interface UserProgramWeek extends WeekProgress {
    programId: ProgramEnum;
    weekNumber: number;
}

export interface ProgramWeek<TWeekSteps = GenericProgramStep[]> {
    id: ProgramWeekEnum;
    title: string;
    iconUrl: string;
    weekNumber: number;
    readableWeekNumber: number;
    steps: TWeekSteps;
    stepsProps: GenericProgramStepProps[];
    definition?: string;
    description?: string;
    feedbackPlaceholder?: string;
    greetingModalContent?: string;
    congratulationsIconUrl?: string;
    congratulationsSneakPeek?: string;
}

export interface ProgramState<TProgramWeeks = GenericProgramWeek[]> {
    id: ProgramEnum;
    title: string;
    iconUrl: string;
    weeks: TProgramWeeks;
    sharedStepsProps?: StepProps[];
}

export interface ProgramsState {
    programsProgress: ProgramsProgress;
    programsProgressFetched: boolean;
    sharedStepsProps: ProgramSharedStepProps[];
}
